import React, { useState, useEffect } from 'react';
import { createAgent, getOrganizations, getRoles } from '../services/api'; // Adjust the path as necessary
import '../css/styles.css'; // Import styles

const AgentForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    organization: '',
    city: '',
    role: '',
    companyLogo: null, // For file upload
    watermarkLogo: null, // For file upload
    ownerId: '', // This will be set from localStorage
  });

  const [organizations, setOrganizations] = useState([]);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const response = await getOrganizations();
        console.log('fetchOrganizations:', response.data);
        setOrganizations(response.data);
      } catch (err) {
        console.error('Failed to fetch organizations', err);
      }
    };

    const fetchRoles = async () => {
      try {
        const response = await getRoles();
        console.log('fetchRoles:', response.data);
        setRoles(response.data);
      } catch (err) {
        console.error('Failed to fetch roles', err);
      }
    };

    fetchOrganizations();
    fetchRoles();

    // Set ownerId from localStorage
    const userId = localStorage.getItem("userId");
    setFormData((prev) => ({
      ...prev,
      ownerId: userId,
    }));
  }, []);

  // Phone number validation function
  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/; // Adjust the regex pattern as needed
    return phoneRegex.test(phone);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate phone number
    if (!validatePhoneNumber(formData.phone)) {
      alert('Please enter a valid phone number.');
      return;
    }

    const data = new FormData();

    // Append agent JSON data
    const agentData = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      organization: formData.organization,
      city: formData.city,
      role: formData.role,
      owner: { id: formData.ownerId }, // Nest owner ID inside an object
    };
    data.append('agent', JSON.stringify(agentData));

    // Append files if they exist
    if (formData.companyLogo && formData.companyLogo[0]) {
      data.append('file', formData.companyLogo[0]); // Attach the company logo
    }

    if (formData.watermarkLogo && formData.watermarkLogo[0]) {
      data.append('file', formData.watermarkLogo[0]); // Attach the watermark logo
    }

    try {
      await createAgent(data); // API call
      alert('Agent registered successfully!');
      resetForm();
    } catch (err) {
      console.error(err);
      alert('Failed to register agent. Please try again.');
    }
  };

  // Reset form data
  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      organization: '',
      city: '',
      role: '',
      companyLogo: null,
      watermarkLogo: null,
      ownerId: localStorage.getItem("userId"), // Reset ownerId from localStorage
    });
  };

  // Handle text input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files, // Store the file list
    }));
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="phone"
          placeholder="Phone"
          value={formData.phone}
          onChange={handleInputChange}
          required
        />
        <select
          name="organization"
          value={formData.organization}
          onChange={handleInputChange}
          required
          className="form-select"
        >
          <option value="">Select Organization</option>
          {organizations.map((org) => (
            <option key={org.id} value={org.id}>
              {org.organizationName}
            </option>
          ))}
        </select>
        <select
          name="role"
          value={formData.role}
          onChange={handleInputChange}
          required
          className="form-select"
        >
          <option value="">Select Role</option>
          {roles.map((role) => (
            <option key={role.id} value={role.id}>
              {role.roleName}
            </option>
          ))}
        </select>
        <input
          type="text"
          name="city"
          placeholder="City"
          value={formData.city}
          onChange={handleInputChange}
          required
        />
        <label>
          Choose File Logo:
          <input
            type="file"
            name="companyLogo"
            onChange={handleFileChange}
            accept="image/*"
          />
        </label>
        <label>
          Choose File Watermark:
          <input
            type="file"
            name="watermarkLogo"
            onChange={handleFileChange}
            accept="image/*"
          />
        </label>
        <button type="submit">Register Agent</button>
      </form>
    </div>
  );
};

export default AgentForm;